import { Box, Button, Drawer, Stack, Tooltip, Typography, Menu, MenuItem, IconButton } from '@mui/material'
import React, { Component } from 'react'
import { Colors } from '../../../Styles/Colors'
import { ImagePaths } from '../../../Utility/ImagePaths'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents'
import { CommonStockTransferPopup } from '../../../Components/Common Components/SubLocCommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import Loader from '../../../Components/Loader';
import SubLocReportFilter from '../Reports/SubLocReportFilter'
import { AddCircle } from '@material-ui/icons'
import TransitDetails from './TransitDetails'
import { CheckAccessFunc, formatDate } from '../../../Components/CommonFunctions/CommonFunctions'
import MoreVertIcon from '@mui/icons-material/MoreVert';

export default class SubLocReturnRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      returnRequestData: [],
      page: 0,
      pageSize: 10,
      returnRequestList: [],
      isViewClick: false,
      selectedData: {},
      selectedRowId: null,
      pageName: 'SubLocationReturn',
      filterDatas: {
        'fromDate': '',
        'toDate': '',
        "dateIndex": 0,
      },
      isTransit: false,
    }
  }
  componentDidMount() {
    this.getReturnRequestData()
  }

  getReturnRequestData = () => {
    try {
      this.LoaderFunction(true)
      var {filterDatas} = this.state
      RestAPIService.getAll(Serviceurls.SUBLOC_STOCK_RETUEN_REQUEST_GET + `?from_date=${filterDatas.fromDate}&to_date=${filterDatas.toDate}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.LoaderFunction(false)
            this.setState({
              returnRequestData: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  closePopupReceive = () => {
    this.setState({
      isViewClick: false,
      selectedData: {},
      selectedRowId: null,
    })
  }

  popupClose = () => {
    this.setState({
      isViewClick: false,
      selectedData: {},
      selectedRowId: null,
    }, ()=>{
      this.getReturnRequestData()
    })
  }
  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  ClosePopUp() {
    this.setState({
      filterOpen: false,
    })
  }

  renderFilter = (data) => {
    this.setState({
      filterDatas: data,
      filterOpen: false,
    }, () => {
        this.getReturnRequestData()
    })
  }
  clearFilter = (data) => {
    this.setState({
      filterDatas: data
    })
  }

  gridToolBar = () => {
    let TextArray = []
    if (this.state.filterDatas.fromDate !== '' && this.state.filterDatas.toDate !== '') {
      TextArray = [
        { label: "From Date", value: formatDate(this.state.filterDatas.fromDate) },
        { label: "To Date", value: formatDate(this.state.filterDatas.toDate) }
      ]
    }
    return (
      <Box emed_tid="subloc_return_request_toolbar">
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} emed_tid="subloc_return_request_toolbar_filter" />
      </Box>
    )
  }

  transitClosePop = () => {
    this.setState({
      isTransit: false
    })}

  getPrint = (id) => {
    try {
      RestAPIService.getAllPrint(Serviceurls.SUBLOC_LINE_OF_ITEM + `?request_id=${id}&export=pdf`).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((e) => {
          if (e?.reponse?.data?.message) {
            this.errorMessage(e?.response?.data?.message)
          } else {
            this.errorMessage(e?.message)
          }
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }


  MoreMenus = (data) => {
    const { t } = this.props
    const multi_option = [
      { value: "Print", label: "Print", dis: false },
    ]
    return (
      <div emed_tid={`subloc_return_request_more_menu_${data?.row?.id}`}>
        <Tooltip title={"More"} placement='top' arrow emed_tid={`subloc_return_request_more_tooltip_${data?.row?.id}`}>
          <IconButton
            onClick={(e) => {
              this.setState({
                anchorEl: e.currentTarget,
                selectedRow: data?.row?.id,
                isSelected: true
              })
            }}
            emed_tid={`subloc_return_request_more_btn_${data?.row?.id}`}
          >
            <MoreVertIcon emed_tid={`subloc_return_request_more_icon_${data?.row?.id}`} />
          </IconButton>
        </Tooltip>
        {(this.state.isSelected && this.state.selectedRow == data?.row?.id) ?
          <Menu
            anchorEl={this.state.anchorEl}
            open={Boolean(this.state.anchorEl)}
            onClose={() => {
              this.setState({ anchorEl: null, })
            }}
            emed_tid={`subloc_return_request_more_menu_${data?.row?.id}`}
          >
              {multi_option.map((option, index) => (
            <MenuItem disabled={option.dis} onClick={() => {
              if(option.value === "ViewCancel"){
                this.setState({
                  isReceiveClicked: true,
                  selectedData: data?.row,
                  selectedRowId: data?.row?.id,
                  is_cancel: true
                })
              }else if(option.value === "Print"){
                this.getPrint(data?.row?.id)
              }
            }} emed_tid={`subloc_return_request_menu_item_${data?.row?.id}_${index}`}>
              <div emed_tid={`subloc_return_request_menu_item_text_${data?.row?.id}_${index}`}>{option.label}</div>
            </MenuItem>))}
          </Menu>
          : null}
      </div>
    )
  }

  render() {
    this.state.returnRequestData.forEach((element, index) => element.sno = index + 1)
    const column = [
      {
        field: 'request_number', headerName: 'Return Stock Transfer No.', flex: 0.125,
        renderCell: (params) => (<Box emed_tid={`subloc_return_request_number_${params.row.sno}`}>{params?.row?.request_number ? params?.row?.request_number : '-'}</Box>)
      },
      {
        field: 'request_date', headerName: 'Stock Transfer Date', flex: 0.125,
        renderCell: (params) => (<Box emed_tid={`subloc_return_request_date_${params.row.sno}`}>{params?.row?.request_date ? params?.row?.request_date : '-'}</Box>)
      },
      {
        field: 'transfer_from', headerName: 'Transferred From', flex: 0.125,
        renderCell: (params) => (<Box emed_tid={`subloc_return_request_transfer_from_${params.row.sno}`}>{params?.row?.transfer_from ? params?.row?.transfer_from : '-'}</Box>)
      },
      {
        field: 'transfer_to', headerName: 'Transferred To', flex: 0.125,
        renderCell: (params) => (<Box emed_tid={`subloc_return_request_transfer_to_${params.row.sno}`}>{params?.row?.transfer_to ? params?.row?.transfer_to : '-'}</Box>)
      },
      {
        field: "transit_name", flex: 0.14, headerName: "Transit Detail", headerAlign: "center", align: "center",
        renderCell: (params) => ((params.row.transit_name && params.row.transit_number) ? 
        <Box emed_tid={`subloc_return_request_transit_${params.row.sno}`}>
            {params?.row?.transit_name?.length > 15 ? 
            <Tooltip title={params?.row?.transit_name} placement='top' emed_tid={`subloc_return_request_transit_name_tooltip_${params.row.sno}`}><Typography sx={{fontWeight: 'bold'}} emed_tid={`subloc_return_request_transit_name_truncated_${params.row.sno}`}>{params?.row?.transit_name.slice(0, 15) + "..."}</Typography></Tooltip> : <Typography sx={{fontWeight: 'bold'}} emed_tid={`subloc_return_request_transit_name_full_${params.row.sno}`}>{params?.row?.transit_name ? params?.row?.transit_name : '-'}</Typography>}
            <Typography sx={{color: Colors.themeDark}} emed_tid={`subloc_return_request_transit_number_${params.row.sno}`}>{params?.row?.transit_number ? params.row.transit_number : '-'}</Typography>
        </Box> : 
          params.row.status === 'In Transit' ? 
          <Box emed_tid={`subloc_return_request_transit_add_${params.row.sno}`}>
            <Button size="small" variant='oulined' sx={{color: Colors.themeDark, fontSize: '1vw', textTransform: 'capitalize'}}
            disabled={CheckAccessFunc("sub_location", "Stock Transfer", "Return Request",  null, "Tab")?.editAccess === false}
            onClick={()=>{this.setState({isTransit: true, selectedRowId: params.row.id})}} className='Common_Btn_Min_Width' startIcon={<AddCircle emed_tid={`subloc_return_request_transit_add_icon_${params.row.sno}`} />} emed_tid={`subloc_return_request_transit_add_btn_${params.row.sno}`}>{'Add Transit Details'}</Button>
          </Box> : <Box emed_tid={`subloc_return_request_transit_empty_${params.row.sno}`}>-</Box>
        )      },
      {
        field: 'no_of_product', headerName: 'No of Product', flex: 0.125, type: 'number',
        renderCell: (params) => (<Box emed_tid={`subloc_return_request_no_of_product_${params.row.sno}`}>{params?.row?.no_of_product ? params?.row?.no_of_product : '-'}</Box>)
      },
      {
        field: 'action', headerName: 'Action', flex: 0.125, headerAlign: 'center', align: 'center',
        renderCell: (params) => (
          <Box sx={{display: 'flex', flexDirection: 'row'}} emed_tid={`subloc_return_request_action_${params.row.sno}`}>
            <Button className='Common_Btn_Min_Width'
              onClick={() => {
                this.setState({
                  isViewClick: true,
                  selectedData: params?.row,
                  selectedRowId: params?.row?.id
                })
              }}
              emed_tid={`subloc_return_request_view_btn_${params.row.sno}`}
            >
              <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'2vw'} width={'2vw'} emed_tid={`subloc_return_request_view_icon_${params.row.sno}`} />
            </Button>
            {this.MoreMenus(params)}
          </Box>
        )
      }
    ]
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '80vh' }} emed_tid="subloc_return_request_container">
        <Box component={'div'} height={'7vh'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} emed_tid="subloc_return_request_header">
          <Box display={'flex'} alignItems={'center'} emed_tid="subloc_return_request_header_left">
            <Button
              size='small'
              disabled={CheckAccessFunc("sub_location", "Stock Transfer", "Return Request",  null, "Tab")?.editAccess === false}
              sx={{ mr: '1vw', height: '2vw', textTransform: 'capitalize' }}
              variant='contained'
              onClick={() => {
                if (this.props.fromOT) {
                  this.props.history.push({ pathname: "/OTStockTransfer/RaiseRequest", state: { page: "return" } })
                }else{
                  this.props.history.push({ pathname: "/SubLocationStockTransfer/RaiseRequest", state: { page: "return" } })
                }
              }}
              emed_tid="subloc_return_request_btn"
            >Return Request</Button>
          </Box>
          <Box component={'div'} height={'7vh'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} emed_tid="subloc_return_request_header_right">
            <Box pr={'1vw'} emed_tid="subloc_return_request_filter_container">
              <Button
                className='eMed_common'
                sx={{ width: '2vw', height: '2vw', mr: '1vw' }}
                onClick={() => this.setState({ filterOpen: true })}
                emed_tid="subloc_return_request_filter_btn"
              >
                <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} emed_tid="subloc_return_request_filter_icon" />
              </Button>
            </Box>
            {/* need to work start */}
            {/* <Box>
              <Button className='eMed_common' sx={{ width: '2vw', height: '2vw', ml: '1vw', mr: '1vw' }}>
                <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} />
              </Button>
              <Button className='eMed_common' sx={{ width: '2vw', height: '2vw', mr: '1vw' }}>
                <Box component={'img'} src={ImagePaths.ExportIcon.default} height={'2vw'} width={'2vw'} />
              </Button>
            </Box> */}
            {/* need to work end */}
          </Box>
        </Box>
        <Box component={'div'} height={'73vh'} p={'1vw'} emed_tid="subloc_return_request_content">
          <DataGrid
            sx={{ backgroundColor: 'white' }}
            columns={column}
            disableColumnFilter
            rows={this.state.returnRequestData}
            getRowId={(row) => row['sno']}
            page={this.state.page}
            pageSize={this.state.pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata' emed_tid="subloc_return_request_no_records">
                  {'No Records To Be Shown'}
                </Stack>
              )
            }}
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            disableSelectionOnClick
            emed_tid="subloc_return_request_datagrid"
          />
          <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
          emed_tid="subloc_return_request_filter_drawer"
        >
          <SubLocReportFilter
            pageName={this.state.pageName}
            filterDatas={this.state.filterDatas}
            closeFilter={this.ClosePopUp.bind(this)}
            filteredData={this.renderFilter.bind(this)}
            ClearData={this.clearFilter.bind(this)}
            ClearFilterDate={"today"}
            emed_tid="subloc_return_request_filter_component" />
        </Drawer>
        </Box>
        {this.state.isViewClick ?
          <CommonStockTransferPopup
            Data={this.state.selectedData}
            title={"Return Details"}
            handlePopUpClose={this.popupClose}
            closePopupReceive={this.closePopupReceive}
            isFromSubLocReq = {true}
            RowId={this.state.selectedRowId}
            emed_tid="subloc_return_request_popup"
          />
          : null}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="subloc_return_request_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="subloc_return_request_success_toast"
          />
          : null}
          {this.state.isTransit ? 
          <TransitDetails
          transitClose={this.transitClosePop}
          id={this.state.selectedRowId}
          triggerApi = {this.getReturnRequestData.bind(this)}
          emed_tid="subloc_return_request_transit_details"
          /> : null}
          <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
